import React, { useMemo } from "react";
import { Typography, Space, Button, message } from "antd";
import { CopyOutlined, LinkOutlined } from "@ant-design/icons";
import {QRCodeCanvas} from "qrcode.react"; // Librería añadida

const { Title, Text } = Typography;

const CashAppQR = ({
  cashtag = "Jessyhermosillo19",
  recipientName = "Jose Hermosillo",
  bordered = true,
  maxWidth = 320,
  style,
  className,
}) => {
  const link = useMemo(() => `https://cash.app/$${cashtag}`.trim(), [cashtag]);
  const fullCashtag = `$${cashtag}`;

  const handleCopy = async () => {
    try {
      await navigator.clipboard.writeText(link);
      message.success("Enlace copiado");
    } catch (e) {
      message.warning("No se pudo copiar el enlace.");
    }
  };

  const handleOpen = () => {
    try {
      window.open(link, "_blank", "noopener,noreferrer");
    } catch (e) {
      message.error("No se pudo abrir el enlace.");
    }
  };

  return (
      <div
        className={className}
        style={{
          maxWidth,
          width: "100%",
          ...style,
          background: "#0b0b0b",
          color: "#fff",
          borderRadius: bordered ? 16 : 0,
          padding: 16,
        }}
      >
        <div
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            marginBottom: 12,
          }}
        >
          <Text style={{ color: "#fff", fontWeight: 600 }}>Cash App</Text>
          <Button shape="round" onClick={handleOpen}>
            Get the app
          </Button>
        </div>

        <Space direction="vertical" style={{ width: "100%" }} size={12} align="center">
          <Text type="secondary" style={{ color: "#b5b5b5" }}>
            Scan to pay with cash app
          </Text>

          <div
            style={{
              background: "#111",
              padding: 16,
              borderRadius: 24,
              boxShadow: "0 0 0 1px #1f1f1f inset",
            }}
          >
            <QRCodeCanvas value={link} size={280} includeMargin={true} bgColor="#111" fgColor="#fff" />
          </div>

          <Title level={3} style={{ color: "#fff", marginBottom: 0 }}>
            {recipientName}
          </Title>
          <Text type="secondary" style={{ color: "#b5b5b5" }}>
            {fullCashtag}
          </Text>

          <Space>
            <Button type="primary" icon={<LinkOutlined />} onClick={handleOpen}>
              Abrir
            </Button>
            <Button icon={<CopyOutlined />} onClick={handleCopy}>
              Copiar enlace
            </Button>
          </Space>
        </Space>
      </div>
  );
};

export default CashAppQR;
